/**
 * Returns the selected scenario, unless it is lower than the scenario count, in which case it returns 1.
 * @param {number} selectedScenario
 * @param {number} scenarioCount
 */
export default function getSelectedPaymentCalculatorScenario(selectedScenario, scenarioCount) {
    return selectedScenario > scenarioCount
        ? 1
        : selectedScenario;
}
